import { Eye, EyeOff } from 'lucide-react';
import * as React from 'react';

import { cn } from '@/shared/lib/cn';
import { Input } from '@/shared/ui/input';

/**
 * Campo de senha com botão de "olho" para revelar o que foi digitado.
 *
 * Encapsula o padrão que estava copiado inline (wrapper `relative` + botão
 * absoluto + alternância do `type`) no LoginPage e no RedefinirSenhaPage. Repassa
 * `ref` e todas as props de `<input>`, então funciona com `{...register(...)}` do
 * react-hook-form sem nada a mais. `type` é fixado aqui — quem usa não escolhe.
 */
export const InputSenha = React.forwardRef<
  HTMLInputElement,
  Omit<React.ComponentProps<'input'>, 'type'>
>(({ className, ...props }, ref) => {
  const [mostrar, setMostrar] = React.useState(false);

  return (
    <div className="relative">
      <Input
        ref={ref}
        type={mostrar ? 'text' : 'password'}
        className={cn('pr-10', className)}
        {...props}
      />
      <button
        type="button"
        onClick={() => setMostrar((v) => !v)}
        aria-label={mostrar ? 'Ocultar senha' : 'Mostrar senha'}
        aria-pressed={mostrar}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-brand/50 hover:text-brand transition-colors"
      >
        {mostrar ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
});
InputSenha.displayName = 'InputSenha';
